/**
 * Remembers which promotion sent someone to the consultant form, so the
 * form's GA4 events can be attributed back to it.
 *
 * Kept in sessionStorage: it should survive the navigation from a page
 * without a form to the contact page, but not outlive the visit.
 */
const STORAGE_KEY = 'ob-form-source';

export function setFormSource(source: string): void {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, source);
  } catch {
    // Blocked storage: the form still works, it just loses the attribution.
  }
}

export function getFormSource(): string | undefined {
  try {
    return window.sessionStorage.getItem(STORAGE_KEY) || undefined;
  } catch {
    return undefined;
  }
}

export function clearFormSource(): void {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Nothing to clear.
  }
}
